{
	"title": "cleanbudget",
	"pageTitle": "{{title}} · cleanbudget",
	"description": "Navulling voor de vloerwisser die je al hebt. De maat staat voorop.",
	"shareImageAlt": "Het woordmerk cleanbudget. met de punt in zeegroen",
	"skipToContent": "Naar de inhoud",
	"home": "Cleanbudget, naar home",
	"nav": {
		"entries": {
			"duster": "Duster",
			"floorWiper": "Vloerwisser",
			"xxl": "XXL",
			"clothsSponges": "Doeken & sponzen",
			"business": "Zakelijk"
		},
		"help": {
			"fitGuide": "Welke past op mijn wisser?",
			"shippingReturns": "Verzenden en retourneren",
			"faq": "Veelgestelde vragen",
			"contact": "Contact",
			"about": "Over ons"
		}
	},
	"header": {
		"navigation": "Winkel",
		"details": {
			"floorWiper": "28×22 cm",
			"xxl": "46×27 cm",
			"clothsSponges": "Microvezeldoeken, wondersponzen",
			"business": "Op rekening, staffelkorting"
		},
		"menu": {
			"open": "Menu",
			"close": "Menu sluiten",
			"label": "Menu"
		},
		"promise": {
			"delivery": "Vóór 17:00 besteld, vandaag verstuurd",
			"noSubscription": "Geen abonnement nodig",
			"shipping": "Verzenden {{rates}}",
			"rate": "{{price}} naar {{country}}"
		},
		"cart_one": "Mand, {{count}} artikel",
		"cart_other": "Mand, {{count}} artikelen",
		"search": {
			"label": "Zoeken",
			"placeholder": "Zoek op product of maat",
			"open": "Zoeken",
			"suggestions": {
				"label": "Suggesties",
				"groups": {
					"product": "Producten",
					"category": "Categorieën",
					"content": "Informatie"
				},
				"all": "Alle resultaten voor ‘{{search}}’",
				"count_one": "{{count}} suggestie",
				"count_other": "{{count}} suggesties",
				"none": "Geen suggesties"
			}
		},
		"signIn": "Inloggen",
		"account": "Account",
		"toast": {
			"title": "In je mand",
			"toCart": "Naar je mand"
		},
		"securePayment": "Veilig betalen via Pay.nl"
	},
	"footer": {
		"shop": "Winkel",
		"help": "Hulp",
		"legal": "Juridisch",
		"company": {
			"title": "Cleanbudget",
			"placeholder": "RS Internetboeken\n[NOG INVULLEN: adres]\nRhenen\nKvK [NOG INVULLEN: nummer]\nBtw [NOG INVULLEN: nummer]"
		},
		"pricesInclVat": "Prijzen incl. 21% btw",
		"pricesExclVat": "Prijzen excl. 21% btw",
		"links": {
			"terms": "Algemene voorwaarden",
			"privacy": "Privacy",
			"cookies": "Cookies",
			"withdrawal": "Herroeping",
			"cookieSettings": "Cookie-instellingen"
		},
		"payment": {
			"title": "Betalen",
			"methods": {
				"ideal": "iDEAL",
				"bancontact": "Bancontact",
				"card": "Creditcard",
				"paypal": "PayPal",
				"bankTransfer": "Overboeking",
				"onAccount": "Op rekening (zakelijk)"
			}
		},
		"checkout": {
			"seller": "{{name}} · {{city}}"
		}
	},
	"price": {
		"from": "vanaf {{price}}",
		"exclVat": "excl. btw",
		"perPiece": "{{price}} per {{noun}}",
		"perPieceFrom": "vanaf {{price}} per {{noun}}",
		"defaultNoun": "stuk",
		"perRefill": "{{price}} per navulling",
		"perNoun": "{{price}} per {{noun}}"
	},
	"notFound": {
		"title": "Pagina niet gevonden",
		"toHome": "Naar de homepage"
	},
	"error": {
		"title": "Er ging iets mis",
		"text": "Probeer het zo nog eens.",
		"retry": "Opnieuw proberen"
	},
	"pages": {
		"home": "De maat staat voorop",
		"products": "Assortiment",
		"category": "Categorie",
		"product": "Product",
		"cart": "Winkelmand",
		"checkout": "Afrekenen",
		"order": "Bestelling {{orderNumber}}",
		"account": "Mijn account",
		"signIn": "Inloggen",
		"forgotPassword": "Wachtwoord vergeten",
		"confirm": "E-mailadres bevestigen",
		"business": "Zakelijk",
		"contact": "Contact",
		"faq": "Veelgestelde vragen",
		"unsubscribe": "Afmelden voor de nieuwsbrief",
		"reorder": "Bestel opnieuw"
	},
	"product": {
		"soldOut": "Uitverkocht",
		"breadcrumb": "Kruimelpad",
		"noPhoto": "Nog geen foto",
		"quantity": "Aantal",
		"less": "Eén minder",
		"more": "Eén meer",
		"addToCart": "In de mand · {{total}}",
		"adding": "Even geduld…",
		"added": "{{quantity}}× {{name}}",
		"unavailable_one": "Er is er nog maar {{count}} beschikbaar.",
		"unavailable_other": "Er zijn er nog maar {{count}} beschikbaar.",
		"soldOutNow": "Dit is net uitverkocht.",
		"notForSale": "Dit is niet meer te koop.",
		"lineLimit": "Je kunt hoogstens {{max}} stuks van een product bestellen. Kijk in je mand hoeveel je er al hebt.",
		"addFailed": "Dat lukte niet. Probeer het nog eens.",
		"holder": {
			"question": "Past dit op je houder?",
			"choose": "Kies je houder. We onthouden het voor de rest van de shop.",
			"fits": "Dit past.",
			"fitsOn": "Past op je houder: {{holder}}.",
			"notFits": "Dit past niet.",
			"notFor": "Niet voor je houder: {{holder}}.",
			"unknown": "Niet zeker.",
			"unknownFor": "Of dit past op je houder ({{holder}}), weten we niet.",
			"fitsYour": "Dit past op je {{holder}}.",
			"notFitsYour": "Dit past niet op je {{holder}}.",
			"unknownYour": "Of dit past op je {{holder}}, weten we niet.",
			"whatFits": "Bekijk wat wel past op {{holder}}",
			"change": "Andere houder"
		},
		"breadcrumbHome": "Home",
		"tile": {
			"pack": "Pak van {{count}}",
			"perPiece": "per {{noun}}",
			"smallestPack": "Kleinste pak",
			"save": "Bespaar {{percent}}%",
			"add": "In mand",
			"addLabel": "In mand: {{name}}",
			"view": "Bekijk"
		}
	},
	"overview": {
		"description": "Alle Nimbus-doekjes op een rij. Met de maat, de houder waar ze op passen en de prijs per doek.",
		"searchTitle": "Zoeken: {{search}}",
		"count_one": "{{count}} product",
		"count_other": "{{count}} producten",
		"home": "Home"
	},
	"sizeLabel": {
		"fits": "past op {{holder}}",
		"notFor": "niet voor {{holder}}"
	},
	"fitLabel": {
		"unconfirmed": "Past op: nog niet bevestigd"
	},
	"shippingBar": {
		"remainingBefore": "Nog",
		"remainingAfter": "tot gratis verzending",
		"progress": "Op weg naar gratis verzending",
		"free": "Je bestelling wordt gratis verzonden."
	},
	"cart": {
		"title": "Mand",
		"close": "Sluiten",
		"loading": "De mand wordt geladen.",
		"loadFailed": "De mand kon niet worden geladen. Probeer het zo nog eens.",
		"empty": {
			"title": "Je mand is leeg",
			"text": "Kies eerst je wisser, dan zie je welke doekjes passen."
		},
		"lines": "Wat er in je mand zit",
		"line": {
			"unitPrice": "{{count}}× {{price}}",
			"pieceFallback": "stuk",
			"quantity": "Aantal",
			"quantityOf": "Aantal van {{product}}",
			"decrease": "Eén minder van {{product}}",
			"increase": "Eén meer van {{product}}",
			"remove": "Verwijderen",
			"removeOf": "{{product}} verwijderen",
			"available": "Nog {{count}} op voorraad. Verlaag het aantal om af te rekenen.",
			"perPiece": "{{price}} per {{noun}}"
		},
		"country": {
			"legend": "Bezorgen in",
			"NL": "Nederland",
			"BE": "België"
		},
		"code": {
			"label": "Kortingscode",
			"apply": "Toepassen",
			"applied": "{{code}} toegepast: {{amount}} korting.",
			"remove": "Weghalen",
			"removeOf": "Kortingscode {{code}} weghalen",
			"placeholder": "Bijv. WELKOM"
		},
		"totals": {
			"goods": "Subtotaal",
			"discount": "Korting",
			"shipping": "Verzenden ({{country}})",
			"shippingNone": "Niet leverbaar",
			"subtotalExcl": "Totaal excl. btw",
			"vatRate": "Btw {{rate}}%",
			"vatIncluded": "waarvan btw ({{rate}}%)",
			"reverseCharge": "Btw verlegd",
			"total": "Totaal",
			"totalIncl": "Totaal incl. btw",
			"discountWithCode": "Korting ({{code}})",
			"goodsAfterDiscount": "Subtotaal na korting"
		},
		"businessNote": "Je ziet zakelijke prijzen, exclusief btw. De btw komt erbij in het totaal.",
		"reverseChargeNote": "Zakelijk naar België: de btw is verlegd. Je betaalt hier geen btw.",
		"checkout": "Afrekenen",
		"toCartPage": "Bekijk je mand",
		"reorderLink": {
			"title": "Bestel opnieuw",
			"busy": "We zetten je bestelling in je mand…",
			"expired": {
				"title": "Deze link is verlopen",
				"text": "Een link om opnieuw te bestellen werkt 180 dagen. Kies je producten in de shop, of log in en bestel opnieuw vanuit je account."
			},
			"invalid": {
				"title": "Deze link werkt niet",
				"text": "Misschien is hij niet helemaal meegekomen. Open de link nog eens vanuit de mail, of kies je producten in de shop."
			},
			"failed": {
				"title": "Dat lukte even niet",
				"text": "Je bestelling staat nog niet in je mand. Probeer het nog eens."
			},
			"retry": "Probeer opnieuw",
			"toShop": "Naar de shop",
			"toAccount": "Naar je account"
		},
		"notice": {
			"variantRemoved": "{{product}} is niet meer te koop en is uit je mand gehaald.",
			"quantityExceedsAvailability": "Van {{product}} hebben we er nog {{count}}. Verlaag het aantal om af te rekenen.",
			"quantityExceedsAvailability_soldOut": "{{product}} is uitverkocht. Haal het uit je mand om af te rekenen.",
			"quantityReduced": "Van {{product}} hebben we er nog {{count}}. Dat aantal staat nu in je mand.",
			"quantityReduced_soldOut": "{{product}} is uitverkocht en staat niet in je mand.",
			"cartsMerged": "Wat je voor het inloggen in je mand deed, staat er nu bij.",
			"countryNotDeliverable": "We bezorgen helaas niet in {{country}}. Kies een ander land.",
			"discountCodeRemoved": "Kortingscode {{code}} is van je mand gehaald. {{reason}}",
			"someProduct": "Een product"
		},
		"rejection": {
			"notFound": "Deze kortingscode kennen we niet.",
			"notYetValid": "Deze kortingscode is nog niet geldig.",
			"expired": "Deze kortingscode is verlopen.",
			"usedUp": "Deze kortingscode is al zo vaak gebruikt als kan.",
			"usedUpByCustomer": "Je hebt deze kortingscode al gebruikt.",
			"customerGroupNotEligible": "Deze kortingscode geldt niet voor jouw account.",
			"noEligibleProducts": "Deze kortingscode geldt niet voor de producten in je mand.",
			"belowMinimumOrderAmount": "Deze kortingscode geldt pas vanaf een hoger bedrag."
		},
		"error": {
			"quantityUnavailable": "Zoveel hebben we er niet. Er zijn er nog {{count}}.",
			"quantityUnavailable_soldOut": "Dit product is uitverkocht.",
			"lineLimit": "Je kunt hoogstens {{max}} stuks van een product bestellen.",
			"lineNotFound": "Dit product zat al niet meer in je mand.",
			"variantNotForSale": "Dit product is niet meer te koop.",
			"unknown": "Dat lukte niet. Probeer het zo nog eens.",
			"codeNotFound": "Deze code kennen we niet. Controleer de spelling."
		},
		"announce": {
			"quantity": "{{product}}: aantal is nu {{count}}.",
			"removed": "{{product}} is uit je mand gehaald.",
			"codeApplied": "Kortingscode {{code}} staat op je mand.",
			"codeRemoved": "De kortingscode is van je mand gehaald.",
			"country": "Bezorgen in {{country}}. Totaal: {{total}}."
		},
		"heading": "Je mand",
		"soldOut": {
			"title": "Een product is net uitverkocht",
			"title_other": "{{count}} producten zijn net uitverkocht",
			"text": "{{products}} is op. We hebben het niet meegeteld.",
			"text_other": "{{products}} zijn op. We hebben ze niet meegeteld.",
			"lineTitle": "Net uitverkocht",
			"lineText": "Dit pak telt niet mee in je totaal. Kies een ander pak of verwijder het.",
			"otherPacks": "Bekijk de andere pakken",
			"otherPacksOf": "Bekijk de andere pakken van {{product}}"
		},
		"promise": "Vóór 17:00 besteld, vandaag verstuurd."
	},
	"validation": {
		"required": "Vul dit in.",
		"tooShort_one": "Gebruik minstens {{count}} teken.",
		"tooShort_other": "Gebruik minstens {{count}} tekens.",
		"tooLong_one": "Gebruik hoogstens {{count}} teken.",
		"tooLong_other": "Gebruik hoogstens {{count}} tekens.",
		"email": "Vul een geldig e-mailadres in, zoals naam@voorbeeld.nl.",
		"choice": "Kies een van de opties.",
		"phone": "Vul een telefoonnummer in, zoals 06 12345678 of +32 470 12 34 56.",
		"postcode": "Vul een postcode in zoals 1234 AB, of 1000 in België.",
		"houseNumber": "Alleen het nummer; een letter of -2 zet je bij de toevoeging.",
		"turnstile": "Wacht even tot de controle hieronder klaar is.",
		"invalid": "Dit klopt niet.",
		"kvkNumber": "Vul je KvK-nummer in: 8 cijfers. Belgisch bedrijf? Dan je KBO-nummer van 10 cijfers.",
		"vatId": "Vul een btw-nummer in zoals NL123456789B01 of BE0123456789."
	},
	"form": {
		"optional": "(niet verplicht)"
	},
	"shipping": {
		"countries": {
			"NL": "Nederland",
			"BE": "België"
		}
	},
	"faq": {
		"description": "Antwoorden op vragen over maten, verzenden, retourneren en betalen.",
		"empty": "Er staan nog geen vragen. Stel je vraag gerust via het contactformulier."
	},
	"errors": {
		"rateLimited": "Je hebt het te vaak geprobeerd. Wacht even en probeer het dan nog eens.",
		"botCheckFailed": "We konden niet controleren of je een mens bent. Probeer het nog eens.",
		"botCheckUnavailable": "De controle tegen spam werkt even niet. Probeer het zo nog eens.",
		"unknown": "Er ging iets mis. Probeer het zo nog eens.",
		"botCheckPending": "Even geduld: de controle tegen spam is nog bezig."
	},
	"newsletter": {
		"title": "Nieuwsbrief",
		"text": "Nieuwe pakken en prijzen in je mail. Hoe vaak: [NOG INVULLEN: hoe vaak]",
		"email": "Je e-mailadres",
		"consent": "Ja, stuur me de nieuwsbrief. Afmelden kan altijd, met de link onder elke mail.",
		"submit": "Aanmelden",
		"done": {
			"title": "Je bent aangemeld."
		},
		"welcome": {
			"text": "Is dit je eerste aanmelding? Dan staat er een welkomstcode in je mail: {{discount}}.",
			"percentage": "{{percent}}% korting",
			"amount": "{{amount}} korting",
			"freeShipping": "geen verzendkosten op je bestelling",
			"minimum": ", vanaf {{amount}} aan producten"
		},
		"errors": {
			"email": "Vul een geldig e-mailadres in.",
			"consent": "Zet het vinkje als je de nieuwsbrief wilt."
		}
	},
	"unsubscribe": {
		"invalid": "Deze afmeldlink klopt niet. Gebruik de link uit de laatste mail, of neem contact op.",
		"text": "Wil je de nieuwsbrief niet meer krijgen? Meld je hieronder af.",
		"submit": "Afmelden",
		"missing": "Deze afmeldlink is niet compleet. Gebruik de link onder de laatste nieuwsbrief, of neem contact op.",
		"done": {
			"title": "Je bent afgemeld.",
			"text": "Je krijgt de nieuwsbrief niet meer. Bedacht? Je kunt je onderaan elke pagina opnieuw aanmelden."
		}
	},
	"contact": {
		"unavailable": "Je bericht kon niet worden verstuurd. Probeer het later nog eens, of mail of bel ons.",
		"problems": {
			"name": {
				"invalid": "Vul je naam in.",
				"tooLong": "Je naam is te lang."
			},
			"email": {
				"invalid": "Vul een geldig e-mailadres in.",
				"tooLong": "Vul een geldig e-mailadres in."
			},
			"orderNumber": {
				"invalid": "Vul een geldig ordernummer in.",
				"tooLong": "Een ordernummer is hooguit 30 tekens."
			},
			"subject": {
				"invalid": "Vul een onderwerp in.",
				"tooLong": "Het onderwerp is te lang."
			},
			"message": {
				"invalid": "Schrijf je bericht.",
				"tooLong": "Je bericht is te lang."
			}
		},
		"description": "Een vraag over je bestelling of over welke maat past? Stuur een bericht, mail of bel.",
		"intro": "Een vraag over je bestelling, of over welke maat op je wisser past? Stuur ons een bericht. Misschien staat het antwoord al bij de",
		"toFaq": "veelgestelde vragen.",
		"service": "Klantenservice",
		"noDetails": "De gegevens van de klantenservice zijn even niet te laden.",
		"fields": {
			"name": "Naam",
			"email": "E-mailadres",
			"emailAccountHint": "(de ontvangstbevestiging gaat naar het adres van je account)",
			"subject": "Onderwerp",
			"message": "Bericht",
			"orderNumberExample": "CBO-100123"
		},
		"sending": "Bezig met versturen…"
	},
	"company": {
		"kvk": "KvK {{kvk}}",
		"vatId": "Btw-nummer {{vatId}}"
	},
	"turnstile": {
		"label": "Controle of je een mens bent"
	},
	"consent": {
		"title": "Cookies",
		"text": "De shop heeft een paar cookies nodig om te werken. Cookies voor statistieken en marketing zetten we alleen als jij dat goed vindt. Je keuze wijzig je later onderaan de pagina.",
		"more": "Meer over cookies",
		"reject": "Weigeren",
		"accept": "Accepteren",
		"customize": "Zelf kiezen",
		"save": "Keuze opslaan",
		"close": "Sluiten",
		"categories": {
			"necessary": {
				"name": "Noodzakelijk",
				"text": "Voor je winkelmand, je account en afrekenen. Staan altijd aan."
			},
			"statistics": {
				"name": "Statistieken",
				"text": "Hoe de shop gebruikt wordt, zodat we hem beter maken."
			},
			"marketing": {
				"name": "Marketing",
				"text": "Meten wat onze advertenties bij Google en Meta opleveren."
			}
		}
	},
	"illustration": {
		"label": {
			"holderDuster": "Duster-handvat met navulling",
			"holderStandard": "Standaard vloerwisser",
			"holderXxl": "XXL-vloerwisser met telescoopsteel",
			"sizeStandard": "Maatdiagram vloerdoekje standaard: 28 bij 22 cm",
			"sizeXxl": "Maatdiagram vloerdoekje XXL: 46 bij 27 cm",
			"measureFoot": "Bovenaanzicht van de voet van een wisser: meet de lengte en de breedte"
		},
		"text": {
			"length": "lengte",
			"width": "breedte"
		}
	},
	"note": {
		"close": "Sluiten"
	},
	"reviews": {
		"stars": "{{average}} van 5 sterren",
		"count_one": "{{count}} review",
		"count_other": "{{count}} reviews",
		"anonymous": "Een koper",
		"verified": "Geverifieerde koper",
		"none": "Nog geen reviews",
		"distribution": {
			"label": "Verdeling van de sterren",
			"stars_one": "{{count}} ster",
			"stars_other": "{{count}} sterren"
		}
	}
}
